<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />
    <TitleSuperAdmin v-if="isAdmin && showTitle" />
    <div class="container modal-breadcrumb">
      <Breacrumb :links="breadCrumbData" />
      <Modal :relacionUS="relacionUS" :getUsers="getUsers" :ministerList="ministerList"/>
    </div>
    <User
      :data="data"
      :columns="columns"
      :getUsers="getUsers"
      :ministerList="ministerList"
    />
  </div>
</template>

<script>
import Title from "../../../components/private/Title.vue";
import TitleSuperAdmin from "../../../components/private/TitleSuperAdmin.vue";
import Breacrumb from "@/components/tools/Breadcrumb.vue";
import User from "./user/User.vue";
import Modal from "./user/Modal.vue";
import { mapState, mapActions } from "vuex";
import { formatRole } from "../../../components/tools/utils";
import axios from "axios";
export default {
  data() {
    return {
      breadCrumbData: null,
      data: [],
      columns: [
        "Nombre",
        "RUT",
        "Email",
        "Perfil",
        "Acceso a Modulo",
        "Acciones",
      ],
      ministerList: null,
    };
  },
  components: {
    Title,
    Breacrumb,
    User,
    Modal,
    TitleSuperAdmin,
  },
  computed: {
    ...mapState("sesion", ["usuario", "relacionUS"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
    showTitle: function() {
      const { path } = this.$route;
      if (path.includes("/admin")) return false;
      return true;
    },
  },
  methods: {
    ...mapActions("sesion", ["setData"]),
    establecerRelacion: function() {
      if (!this.usuario) return;
      if (this.usuario.username === process.env.VUE_APP_USER_ADMIN) return;
      const service = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );

      this.setData({
        idUsuario: this.$route.params.idUsuario,
        idServicio: service.id,
        ministerio: service.ministerio,
        perfil: formatRole(service.rolNombre),
        rolId: service.rolId,
        nombreServicio: service.nombre,
        usuarioServicioId: service.usuarioServicioId,
      });
    },
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.$route.params.idUsuario,
          },
        },
        {
          name: "Configuraciones",
          routeName: "acceso",
          routeParams: {
            ...this.$route.params,
          },
        },
      ];
    },
    getUsers: async function() {
      try {
        this.data = [];
        const token = localStorage.getItem("userToken");
        let res;
        // const userServicio = this.usuario.servicios.find(
        //   (s) => s.id === this.$route.params.idServicio
        // );
        if (this.$route.params.idServicio === 31) {
          res = await axios.get(
            `${process.env.VUE_APP_RUTA_API}/usuarios/usuarios/`,
            {
              headers: {
                Authorization: `JWT ${token}`,
              },
            }
          );
          this.data = res.data;
          this.columns = ["Nombre", "RUT", "Email", "Acciones"];
        } else {
          res = await axios.get(
            `${process.env.VUE_APP_RUTA_API}/usuarios/usuarios?servicio=${this.$route.params.idServicio}`,
            {
              headers: {
                Authorization: `JWT ${token}`,
              },
            }
          );

          this.data = res.data.filter(
            (u) => u.username !== process.env.VUE_APP_USER_ADMIN
          ).filter(u=>{return u.username.indexOf('-')>0})
          .filter(u=>{return u.username.indexOf('13961548')<0})
          .filter(u=>{return u.username.indexOf('17088584')<0})
// if (userServicio.rolId === 2) {
          //   this.data = usersFromActualService;
          // } else if (userServicio.rolId === 3 || userServicio.rolId === 6) {
          //   usersFromActualService.forEach((us) => {
          //     if (us.rol.id === 4 || us.rol.id === 6 || us.rol.id === 3) {
          //       this.data.push(us);
          //     }
          //   });
          // } else if (userServicio.rolId === 4) {
          //   usersFromActualService.forEach((us) => {
          //     if (
          //       us.rol.id === 4 ||
          //       us.rol.id === 6 ||
          //       us.rol.id === 5 ||
          //       us.rol.id === 3
          //     ) {
          //       this.data.push(us);
          //     }
          //   });
          // }
        }
        this.showListUsers = true;
      } catch (error) {
        console.log(error.response.data);
      }
    },
    getMinisterList: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/ministerios/`
        );

        this.ministerList = res.data.map((m) => ({
          value: m.id,
          text: m.nombre,
        }));

        this.ministerList.unshift({
          value: null,
          text: "- Seleccione un Ministerio -",
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.establecerRelacion();
    this.setBreadcrumbData();
    this.getMinisterList();
    setTimeout(() => {
      this.getUsers();
    }, 200);
  },
};
</script>
<style scoped>
.modal-breadcrumb {
  display: flex;
  padding: 10px 0 !important;
}
</style>
